import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class RedditAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'reddit';
	getListPostByKey(slug) {
		let request = {
			url: [this.getAPIUrl(), slug , 'posts', ].join('/')
		};
		return httpClient.getAsync(request);
	}	
	getDetailByKey(slug) {
		let request = {
			url: [this.getAPIUrl(), slug].join('/')
		};
		return httpClient.getAsync(request);
	}
}

export default new RedditAPI();